import React, { useState } from "react";
import { FaEdit, FaPlus, FaTimes } from "react-icons/fa";
import { useSelector } from "react-redux";
import {
  deleteTopic,
  getDeleteTopicError,
  getDeleteTopicStatus,
  getEditTopicStatus,
  setEditAndDeleteTopicandSubjectIdleStatus,
} from "../../../redux/slice/topicSlice";
import AlertBox from "../../common/AlertBox";
import Loading from "../../common/Loading";
import DeleteButton from "../common/DeleteButton";
import AddSubjectForm from "./AddSubjectForm";
import EditTopicForm from "./EditTopicForm";
import SubjectItem from "./SubjectItem";

const TopicItem = ({ topic }) => {
  const editStatus = useSelector(getEditTopicStatus);
  const deleteStatus = useSelector(getDeleteTopicStatus);
  const error = useSelector(getDeleteTopicError);

  const [addSubjectForm, setAddSubjectForm] = useState(false);

  const [editActive, setEditActive] = useState(false);

  const handleAddSubject = () => {
    setAddSubjectForm((prev) => !prev);
  };

  return (
    <div className="flex flex-col gap-2 border-b-2 py-6 px-4">
      {editStatus === "loading" || deleteStatus === "loading" ? (
        <Loading />
      ) : null}
      {editStatus === "success" ? (
        <AlertBox
          type="success"
          message="Topic edited successfully"
          toDispatch={setEditAndDeleteTopicandSubjectIdleStatus}
        />
      ) : null}

      {deleteStatus === "success" ? (
        <AlertBox
          type="success"
          message="Topic deleted successfully"
          toDispatch={setEditAndDeleteTopicandSubjectIdleStatus}
        />
      ) : null}
      {deleteStatus === "failed" ? (
        <AlertBox
          type="failed"
          message={error}
          toDispatch={setEditAndDeleteTopicandSubjectIdleStatus}
        />
      ) : null}

      {/* Topic Name || Edit the topic|| show edit icon on hover only */}
      <div className="flex justify-between">
        {editActive ? (
          <EditTopicForm topic={topic} setEditActive={setEditActive} />
        ) : (
          <div className="flex flex-row gap-3 items-center hoverEffect pr-8">
            <h3 className="text-textPrimary font-medium text-[18px]">
              {topic?.topicName}:
            </h3>
            <div className="edit flex-row gap-3">
              <FaEdit
                onClick={() => setEditActive(true)}
                className="text-blue-700 cursor-pointer"
              />
              <DeleteButton
                data={topic._id}
                toDispatch={deleteTopic}
                type="Topic"
              />
            </div>
          </div>
        )}

        {/* Show all subjects of the current topic || edit and add subject */}
        <div className="flex gap-4 justify-center">
          <button
            onClick={handleAddSubject}
            className="bg-adminRightTextPrimary px-2 py-1 rounded-[4px] flex gap-2 items-center h-[28px] text-sm"
          >
            {/* Show relevent content on the button */}
            <div className="flex gap-2 justify-center items-center text-white">
              {addSubjectForm ? <FaTimes /> : <FaPlus />}
              <span className="sm:block hidden">
                {addSubjectForm ? "Close" : "Subject"}
              </span>
            </div>
          </button>
        </div>
      </div>

      {/* Show add subject form only when button is clicked */}
      {addSubjectForm ? <AddSubjectForm topicId={topic?._id} /> : null}

      {/* Subject List */}
      <div className="grid md:grid-cols-12 sm:grid-cols-6 grid-cols-3 gap-4 px-4 items-center text-center">
        {topic?.subjectDetails?.length === 0 ? (
          <p className="text-red-500 col-span-3">No subjects</p>
        ) : (
          topic?.subjectDetails?.map((subject) => (
            <SubjectItem
              key={subject._id}
              subject={subject}
              topicId={topic._id}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default TopicItem;
